import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { isNullOrEmpty } from "../../common/commonFuncs";

const CreateNewDialog = ({ handleNew, Type }) => {
  const [open, setOpen] = React.useState(false);
  const [name, setName] = React.useState("");
  const [valid, setValid] = React.useState(true);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setName("");
    setValid(true);
    setOpen(false);
  };

  const handleAdd = () => {
    if (isNullOrEmpty(name.trim())) {
      setValid(false);
    } else {
      setValid(true);
      handleNew(name.trim());
      setName("");
      handleClose();
    }
  };

  const handleChange = (e) => {
    setName(e.target.value);
  };

  return (
    <React.Fragment>
      <div className="float-right">
        <button
          className="btn btn-outline-blue rounded-0"
          onClick={handleClickOpen}
        >
          + New {Type}
        </button>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">New {Type}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This {Type.toLowerCase()} will be put under the current project.
          </DialogContentText>
          <TextField
            autoFocus
            id={"new" + Type + "Name"}
            label={Type + " Name"}
            value={name}
            onChange={handleChange}
            fullWidth
            helperText={valid ? "" : "Cannot be empty"}
            error={!valid}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleAdd} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default CreateNewDialog;
